import { connect } from 'react-redux';
import ExpenseActionPage from './ExpenseActionPage';

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExpenseActionPage);
